export interface SetupProfile {
  firstInitiativeSummary: string;
  firstInitiativeTitle: string;
  handoffPrompt: string;
  id: string;
  label: string;
  localProofCommand: string;
  skillDiscoveryCommand: string;
}

export const SETUP_PROFILES: Record<string, SetupProfile> = {
  "local-ai-workflow": {
    id: "local-ai-workflow",
    label: "Local AI workflow",
    firstInitiativeTitle: "Make local AI work visible and shippable",
    firstInitiativeSummary: [
      "First OrgX initiative tailored for a local AI-assisted workflow.",
      "Use local AI-session evidence, Git/GitHub proof, and existing project context to create a live work graph, a concrete onboarding task, and a path to cloud execution once GitHub is connected.",
    ].join(" "),
    handoffPrompt:
      "Use OrgX to continue this local AI-workflow initiative. Start with the onboarding task, inspect local AI-client and GitHub proof, preserve selected local skills, and show the next action plus the cloud handoff once GitHub is connected.",
    localProofCommand:
      "orgx-wizard sessions reconcile --from opencode,github --public-share --yes",
    skillDiscoveryCommand:
      "orgx-wizard skills discover-local --from opencode,claude,codex,workspace --context \"Describe this person's domain, tools, and workflow\"",
  },
};

export function listSetupProfiles(): SetupProfile[] {
  return Object.values(SETUP_PROFILES).map((profile) => ({ ...profile }));
}

export function resolveSetupProfile(id?: string): SetupProfile | null {
  const normalized = id?.trim().toLowerCase();
  if (!normalized) return null;
  return SETUP_PROFILES[normalized] ?? null;
}

export function supportedSetupProfileIds(): string[] {
  return Object.keys(SETUP_PROFILES).sort();
}

export function buildProfileSummary(profile: SetupProfile, context?: string): string {
  const trimmedContext = context?.trim();
  if (!trimmedContext) return profile.firstInitiativeSummary;
  return `${profile.firstInitiativeSummary} Context: ${trimmedContext}`;
}

export function buildProfileHandoffPrompt(
  profile: SetupProfile | null | undefined,
  fallbackPrompt: string,
  context?: string,
): string {
  if (!profile) return fallbackPrompt;
  const trimmedContext = context?.trim();
  return trimmedContext
    ? `${profile.handoffPrompt} Context: ${trimmedContext}`
    : profile.handoffPrompt;
}
